import { API_CONFIG } from '@/config/api';
import { httpClient } from '@/utils/httpClient';
import type { AssetTransactionRecord } from '@/types/Transactions';

interface TransactionsLatestResponse {
  transactions: AssetTransactionRecord[];
}

export class TransactionService {
  async listLatest(
    limit = 200,
    options?: { from?: string; to?: string; types?: string },
  ): Promise<AssetTransactionRecord[]> {
    const searchParams = new URLSearchParams({
      limit: String(limit),
    });

    if (options?.from) {
      searchParams.set('from', options.from);
    }
    if (options?.to) {
      searchParams.set('to', options.to);
    }
    if (options?.types) {
      searchParams.set('types', options.types);
    }

    const endpoint = `${API_CONFIG.ENDPOINTS.TRANSACTIONS_LATEST}?${searchParams.toString()}`;
    const response = await httpClient.get<TransactionsLatestResponse>(endpoint);
    if (response && Array.isArray(response.transactions)) {
      return response.transactions;
    }
    return [];
  }
}

export const transactionService = new TransactionService();
